import messages from './messages';

export const HEADER = 'HEADER';
export const ITEMS_HEADER = 'ITEMS_HEADER';
export const ITEMS = 'ITEMS';
export const FOOTER = 'FOOTER';

export const SIZE_4X6 = '4x6';
export const SIZE_LETTER = 'Letter';
// TODO: pending to review with BE indexes
export const SIZE_A4 = 'A4';
export const SIZE_A6 = 'A6';

export const defaultTemplateSizes = [
  { value: SIZE_4X6, label: messages.fourBySixSizeValue },
  { value: SIZE_LETTER, label: messages.eightByElevenSizeValue },
];
// TODO: [SPD-19601]: Remove this logic when feature flag is removed and merge both into just one

export const newTemplateSizes = [
  { value: SIZE_A4, label: messages.a4SizeValue },
  { value: SIZE_A6, label: messages.a6SizeValue },
];
